module.exports = __webpack_public_path__ + "static/media/achievement4.5194edf5.png";